// Calcolo durata viaggio
interface DurationOptions {
  fallbackText?: string;
  t?: (key: string, options?: any) => string;
}

export function calculateDuration(
  startDate?: string | null,
  endDate?: string | null,
  options: DurationOptions = {}
): string {
  const { 
    fallbackText = "Durata flessibile",
    t
  } = options;

  if (startDate && endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = Math.abs(end.getTime() - start.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (t) {
      return `${diffDays} ${diffDays === 1 ? t('common.day') : t('common.days')}`;
    }
    
    // Fallback per retrocompatibilità
    return `${diffDays} ${diffDays === 1 ? 'day' : 'days'}`;
  }
  
  return fallbackText || (t ? t('itinerary.flexibleDuration') : 'Flexible duration');
}
